import React, { useState } from 'react';
import './RoomSelectionStep.css';
import { Room, Shop } from '../../models/types';
import { getRoomImageUrl } from '../../utils/roomImages';

interface RoomSelectionStepProps {
    shop: Shop;
    rooms: Room[];
    selectedRoom: Room | null;
    onRoomSelect: (room: Room) => void;
}

const RoomImage: React.FC<{
    shopId: number;
    shopName: string;
    roomNum: number;
    roomName: string;
}> = ({ shopId, shopName, roomNum, roomName }) => {
    const imageUrl = getRoomImageUrl(shopId, roomNum, shopName);
    const fallbackUrl = `https://via.placeholder.com/400x300/007bff/ffffff?text=${encodeURIComponent(roomName)}`;
    const [src, setSrc] = useState(imageUrl ?? fallbackUrl);

    return (
        <img
            src={src}
            alt={roomName}
            className="room-image"
            onError={() => {
                if (src !== fallbackUrl) {
                    setSrc(fallbackUrl);
                }
            }}
        />
    );
};

const RoomSelectionStep: React.FC<RoomSelectionStepProps> = ({
    shop,
    rooms,
    selectedRoom,
    onRoomSelect,
}) => {
    const handleRoomClick = (room: Room) => {
        onRoomSelect(room);
    };

    return (
        <div className="room-selection-step">
            <div className="rooms-grid">
                {rooms.map((room) => (
                    <div
                        key={room.room_id}
                        className={`room-card ${selectedRoom?.room_id === room.room_id ? 'selected' : ''}`}
                        onClick={() => handleRoomClick(room)}
                    >
                        <div className="room-name-top">{room.room_name}</div>
                        <div className="room-image-container">
                            <RoomImage
                                key={`${shop.shop_id}-${room.room_num}`}
                                shopId={shop.shop_id}
                                shopName={shop.shop_name}
                                roomNum={room.room_num}
                                roomName={room.room_name}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RoomSelectionStep;
